import { render, staticRenderFns } from "./newgroup.vue?vue&type=template&id=b4f9f6f0&scoped=true&"
import script from "./newgroup.vue?vue&type=script&lang=js&"
export * from "./newgroup.vue?vue&type=script&lang=js&"
import style0 from "./newgroup.vue?vue&type=style&index=0&id=b4f9f6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f9f6f0",
  null
  
)

export default component.exports